import React from 'react';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import PremiumDownloadIcon from '@wix/da-ds/pkg/Icons/24x24/PremiumDownload';
import useDeviationStats from './useDeviationStats';
import Stat from './Stat';
const PremiumDownloadStat = ({ deviation, onlyNumbers, className })=>{
    const { premiumDownloads } = useDeviationStats(deviation);
    // don't display 0 downloads
    const isShown = !!premiumDownloads;
    return isShown ? /*#__PURE__*/ React.createElement(Stat, {
        className: className,
        deviation: deviation,
        icon: PremiumDownloadIcon,
        statNameLocaleKey: "deviation.stats.premiumDownloads",
        statCount: premiumDownloads,
        onlyNumbers: onlyNumbers,
        biData: BiData({
            evid: 2,
            click_info: 'premiumDownloads',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    }) : null;
};
PremiumDownloadStat.displayName = 'PremiumDownloadStat';
export default PremiumDownloadStat;

//# sourceMappingURL=PremiumDownloadStat.js.map